import ScreenContainer from './screen-container';

export default ScreenContainer;
